import { Field, ID, InputType } from 'type-graphql'
import { ActionArgs } from '../../action/ActionArgs'
import type { IAction } from '../../action/IAction'
import { ShippingPackage } from '../../shipping/ShippingPackage'
import type { Logistic } from '../Logistic'

@InputType()
export class ShipLogisticArgs extends ActionArgs {
  @Field(() => ID)
  logisticId: string

  //what the user built in the package editor; the record's own shipping.rate is what gets bought,
  //so there is no rateId here
  @Field(() => [ShippingPackage])
  packages?: ShippingPackage[]
}

export interface IShipLogistic extends IAction<Logistic, ShipLogisticArgs> {}
